import axios from 'axios';
import API from '../config/api';

// Keep legacy descriptions intact when first opening the combined editor.
export function getPujaAbout(puja, language) {
  const combined = puja[`about_content_${language}`];
  if (typeof combined === 'string') return combined;
  const headings = language === 'hi'
    ? ['पूजा परिचय', 'मंदिर परिचय', 'भगवान परिचय']
    : ['About Puja', 'About Mandir', 'About Bhagwan'];
  return ['puja', 'temple', 'deity'].map((section, index) => {
    const content = puja[`about_${section}_${language}`]
      || (language === 'en' ? puja[`about_${section}`] : '')
      || (language === 'en' && section === 'puja' ? puja.description : '');
    return content ? `<h3>${headings[index]}</h3>\n${content}` : '';
  }).filter(Boolean).join('\n\n');
}

export function formatPujaPackages(packages) {
  if (!packages.length) throw new Error('At least one package is required');
  return packages.map((pkg, index) => {
    const price = Number(pkg.price);
    const devotees = Number(pkg.devotees_count);
    if (!pkg.name?.trim()) throw new Error(`Enter a name for package ${index + 1}`);
    if (String(pkg.price).trim() === '' || !Number.isFinite(price) || price < 0) {
      throw new Error(`Enter a valid price for package ${index + 1}`);
    }
    if (!Number.isInteger(devotees) || devotees < 1) {
      throw new Error(`Enter a valid devotee count for package ${index + 1}`);
    }
    return { ...pkg, name: pkg.name.trim(), price, devotees_count: devotees,
      benefits: (pkg.benefits || []).map(benefit => benefit.trim()).filter(Boolean) };
  });
}

export function getPujaStartingPrice(packages) {
  const activePackages = packages.filter(pkg => pkg.is_active !== false);
  return Math.min(...(activePackages.length ? activePackages : packages).map(pkg => pkg.price));
}

export function getPujaDescription(form) {
  const html = form.about_content_en || form.about_content_hi || '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent.replace(/\s+/g, ' ').trim() || form.name;
}

export const isAvailableOffering = item => item.is_active !== false && item.is_deleted !== true;

// The store endpoint is paginated; load every page so all products are selectable.
export async function fetchPujaProducts() {
  const products = [];
  let page = 1;
  while (true) {
    const { data } = await axios.get(`${API}/products`, { params: { page, limit: 100 } });
    const items = Array.isArray(data) ? data : data.products || [];
    products.push(...items.filter(isAvailableOffering));
    if (Array.isArray(data) || !items.length || !(data.hasMore || page < data.totalPages)) break;
    page += 1;
  }
  return products;
}
